import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Alert,
  Card,
} from "react-bootstrap";
import "../RolEmpleado/RecargaSaldo/RecargaSaldo.css";
import QRCode from "react-qr-code";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";

function GenerarQRDinamico() {
  const [monto, setMonto] = useState("");
  const [error, setError] = useState("");
  const [showQrModal, setShowQrModal] = useState(false);
  const [isSearching, setIsSearching] = useState(false); // Estado para manejar si está buscando pasajero
  const [rawQr, setRawQr] = useState(null);
  const idQr = useRef(null);

  // const yaPagado = async (idQR) => {
  //   try {
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_URL}/public/v2/Admin/List/QR`,
  //        { 'idQr': idQR,},
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'SERVICIOS-URBANOS-TOKEN': localStorage.getItem('token'),

  //         }
  //       }
  //     );
  //     console.log(response)
  //     if (response.data && response.data.lista) {

  //       pagoFinalizadoRef.current = true;
  //       idQr.current = null;
  //       setRecargaConfirmada(true);
  //       setShowQrModal(false);

  //       Swal.fire({
  //         icon: "success",
  //         title: "Pago exitoso",
  //         text: "El pago se realizó correctamente.",
  //       });

  //       wsRef.current?.close();
  //     } else {
  //       console.log("no pagado")
  //     }
  //   } catch (error) {
  //     console.error(error)
  //     setError('ERROR',error);
  //   }
  // };
  const generarQR = async () => {
    const montoNumber = Number(monto).toFixed(2);
    setIsSearching(true); // Activamos el estado de búsqueda
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/public/v2/QR/Dinamico`,
        { total: montoNumber },

        {
          headers: {
            "Content-Type": "application/json",
            "SERVICIOS-URBANOS-TOKEN": localStorage.getItem("token"),
          },
        }
      );
      console.log("qr dinamico", response.data.ok);

      if (response.data.ok) {
        setRawQr(response.data.qr);
        setShowQrModal(true);
        idQr.current= response.data.idQr

        setError("");
      } else {
        setError(response.data.msg);
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        setError(error.response.data.msg);
      } else {
        setError("Error al generar el QR. Inténtalo de nuevo.");
      }
    } finally {
      setIsSearching(false); // Restauramos el estado de búsqueda
    }
  };

  const handleNuevoQR = () => {
    setRawQr(null);
    setMonto("");
    setShowQrModal(false);
  };

  const wsRef = useRef(null);

  const pagoFinalizadoRef = useRef(false);
  const reconnectTimeoutRef = useRef(null);

  const connectWS = () => {
    if (pagoFinalizadoRef.current) return;
    console.log("Conectando al WebSocket...");

    wsRef.current = new WebSocket(process.env.REACT_APP_URL_WS);

    wsRef.current.onopen = () => {
      wsRef.current.send(
        JSON.stringify({
          type: "AUTH",
          token: localStorage.getItem("token"),
        })
      );
    };

    wsRef.current.onmessage = (event) => {
      let data;

      try {
        data = JSON.parse(event.data);
        if (typeof data === "string") data = JSON.parse(data);
      } catch {
        return;
      }

      if (data.msg === "Autenticado" && data.status === 200) {
        wsRef.current.send(
          JSON.stringify({
            type: "PAGO QR",
            idQR: idQr.current,
            token: localStorage.getItem("token"),
          })
        );
      }

      if (data.type === "PAGO FINALIZADO" && data.ok === true) {
        pagoFinalizadoRef.current = true;
        idQr.current = null;
        setShowQrModal(false);
        setMonto("");

        Swal.fire({
          icon: "success",
          title: "Pago exitoso",
          text: "El pago se realizó correctamente.",
        });

        wsRef.current?.close();
      }
      if (data.type === "PAGO FINALIZADO" && data.ok === false) {
        pagoFinalizadoRef.current = true;
        idQr.current = null;
        setShowQrModal(false);
        setMonto("");
        Swal.fire({
          icon: "error",
          title: "Error en el pago",
          text: data.msg || "Hubo un error al procesar el pago.",
        });

        wsRef.current?.close();
      }
    };

    wsRef.current.onclose = () => {
      wsRef.current = null;
      if (showQrModal && !pagoFinalizadoRef.current) {
        reconnectTimeoutRef.current = setTimeout(() => {
          connectWS();
        }, 3000);
      }
    };

    wsRef.current.onerror = () => {
      wsRef.current?.close();
    };
  };

  useEffect(() => {
    if (!showQrModal || !rawQr) return;

    pagoFinalizadoRef.current = false;

    connectWS();

    return () => {
      clearTimeout(reconnectTimeoutRef.current);
      wsRef.current?.close();
      wsRef.current = null;
    };
  }, [showQrModal, rawQr]);

  useEffect(() => {
    const handleOnline = () => {
      console.log("se perdio el internet, reconectando al ws...");
      if (showQrModal && !pagoFinalizadoRef.current) {
        connectWS();
      }
    };

    window.addEventListener("online", handleOnline);
    return () => window.removeEventListener("online", handleOnline);
  }, [showQrModal]);
  return (
    <Container className="recarga-container">
      <Card className="recarga-card">
        <Row className="justify-content-md-center">
          <Col md="12">
            <h2 className="recarga-header">Generar QR dinámico</h2>
            {error && <Alert variant="danger">{error}</Alert>}
            <Form>
              <Form.Group controlId="formCuitPasajero">
                <Form.Label style={{ marginTop: "10px" }}>
                  Ingrese el monto
                </Form.Label>
                <Form.Control
                  type="number"
                  value={monto}
                  onChange={(e) => {
                    setMonto(e.target.value);
                  }}
                />
              </Form.Group>
              {
                <Button
                  variant="primary"
                  onClick={generarQR}
                  className="recarga-button-confirm"
                  disabled={isSearching} // Deshabilitar si está buscando o si el CUIT no está ingresado
                >
                  {isSearching ? "Generando..." : "Generar QR"}
                </Button>
              }
            </Form>
            <Modal
              show={showQrModal}
              onHide={() => setShowQrModal(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Escaneá el QR</Modal.Title>
              </Modal.Header>

              <Modal.Body className="text-center">
                {rawQr && (
                  <div style={{ background: "white", padding: 16 }}>
                    <QRCode value={rawQr} size={350} />
                  </div>
                )}

                <p style={{ marginTop: 12 }}>
                  Total: <strong>${monto ? monto : 0}</strong>
                </p>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowQrModal(false)}
                >
                  Cerrar
                </Button>
                <Button variant="primary" onClick={() => handleNuevoQR()}>
                  Generar Nuevo QR
                </Button>
              </Modal.Footer>
            </Modal>
          </Col>
        </Row>
      </Card>
    </Container>
  );
}

export default GenerarQRDinamico;
